exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.formatter-layout.container[data-v-492ac893] {\n  max-height: 100vh;\n}\n.mpe-editor-container[data-v-492ac893] {\n  width: 75%;\n  min-width: 500px;\n  max-width: 1000px;\n}\n.formatter-layout.warning[data-v-492ac893] {\n  background-color: #FFFFFF;\n  border-radius: 4px;\n  padding: 10px 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n@media (max-width: 768px) {\n.editor-main[data-v-492ac893] {\n    padding-bottom: 10px;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-492ac893","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/service/campaignManager/CampaignMpeEditor.vue
// module id = Aou0
// module chunks = 53